import { render } from "./AppCommunications.vue?vue&type=template&id=3874bd55"
import script from "./AppCommunications.vue?vue&type=script&lang=js"
export * from "./AppCommunications.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\anda\\Documents\\onlinefundraising\\of_spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__